import CollInfoStore from '../store/CollInfoStore';
import { fetchFromJson } from './fetchFromJson';

const db = new CollInfoStore('collInfoStore');

const updateCache = 'collInfo_updateCache';
const getUpdateCache = (data) => data.coll_info;
const toast = 'Coll Info Updated';
const entityName = 'collInfo';

export default (WrappedComponent) => fetchFromJson({
  WrappedComponent,
  getUpdateCache,
  db,
  updateCache,
  toast,
  entityName,
});
